// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3_Yda","header":"ReportDetails_header__1O778","title":"ReportDetails_title__2Do9A","left":"ReportDetails_left__3zLT3"};